import _Vue from 'vue';

export default {
  install(Vue: typeof _Vue) {
    Vue.directive('lazyLoad', {
      bind(el: HTMLElement, binding) {
        el.dataset.src = binding.value;
        io.observe(el);
      },
    });
    const io = new IntersectionObserver((entries) => {
      entries.forEach((item: any) => {
        const { target, isIntersecting } = item;

        if (!isIntersecting) {
          return;
        }
        if (target.tagName === 'IMG' && target.dataset.src) {
          target.src = target.dataset.src;
        } else if (target.tagName === 'DIV' && target.dataset.src) {
          target.style.backgroundImage = `url(${target.dataset.src})`;
        }
        io.unobserve(target);
      });
    });
  },
};
